// extracted by mini-css-extract-plugin
export default {"insights":"Example_insights__mq9W+","wrapper":"Example_wrapper__7WTla","heading-3":"Example_heading-3__U49Y3"};